interface IDownloadDOM {
  url: string;
  documentName: string;
}

export function downloadAttachment({ url, documentName }: IDownloadDOM) {
  window.open(url, '_blank');
}
